function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18n from 'invision-core/src/components/i18n/i18n';
import { PRODUCT_CLASSIFICATIONS } from 'invision-core/src/constants/product.constants';
import CustomerCareKeys from '../../../../../../../../locales/keys';
import { GetProductStructureTypes } from '../../../../../../../../reducers/constants/structure.type.constants';
var CATEGORY_VALUE = 'Id';
var FACET_VALUE = 'Value';
var STRUCTURE_TYPE_VALUE = 'id';
var FACET_LIST_PROPERTY = 'subFacets';
var CATEGORY_LIST_PROPERTY = 'Children';
var CategoryFiltersController = /*#__PURE__*/function () {
  function CategoryFiltersController() {
    _classCallCheck(this, CategoryFiltersController);
    Object.assign(this, {
      customerCareKeys: CustomerCareKeys,
      onRecurrenceChanged: this.onRecurrenceChanged.bind(this),
      onClearStructureType: this.onClearStructureType.bind(this),
      onStructureTypeChanged: this.onStructureTypeChanged.bind(this),
      onFacetChanged: this.onFacetChanged.bind(this),
      onClearFacet: this.onClearFacet.bind(this),
      onSubFacetChanged: this.onSubFacetChanged.bind(this),
      onClearCategory: this.onClearCategory.bind(this),
      onCategoryChanged: this.onCategoryChanged.bind(this),
      onSubCategoryChanged: this.onSubCategoryChanged.bind(this),
      onClearFacetsCategories: this.onClearFacetsCategories.bind(this),
      onClassChanged: this.onClassChanged.bind(this),
      structureTypes: GetProductStructureTypes(),
      productClassification: PRODUCT_CLASSIFICATIONS.NONE,
      //Setting default to All
      productClassifications: PRODUCT_CLASSIFICATIONS,
      productClassificationFilters: [{
        id: PRODUCT_CLASSIFICATIONS.NONE,
        label: i18n.translate(CustomerCareKeys.ALL)
      }, {
        id: PRODUCT_CLASSIFICATIONS.PRODUCT,
        label: i18n.translate(CustomerCareKeys.PRODUCT)
      }, {
        id: PRODUCT_CLASSIFICATIONS.AD_HOC,
        label: i18n.translate(CustomerCareKeys.AD_HOC)
      }],
      selectedStructureTypes: [],
      selectedFacets: [],
      selectedCategories: []
    });
  }
  return _createClass(CategoryFiltersController, [{
    key: "$onInit",
    value: function $onInit() {
      this.initPersistence();
      this.setSubscriptionValue();
    }
  }, {
    key: "initPersistence",
    value: function initPersistence() {
      if (this.usePersistence) {
        this.initRecurrence(this.searchCatalogParams);
        this.initStructureTypes();
      } else {
        this.clearCategories(this.categories);
        this.clearFacets(this.facets);
      }
    }
  }, {
    key: "clearCategories",
    value: function clearCategories(categories) {
      var _this = this;
      categories && categories.forEach(function (category) {
        _this._clearCategory(category);
      });
    }
  }, {
    key: "clearFacets",
    value: function clearFacets(facets) {
      var _this2 = this;
      facets && facets.forEach(function (facet) {
        _this2._clearFacet(facet);
      });
    }
  }, {
    key: "initRecurrence",
    value: function initRecurrence() {
      if (this.searchCatalogParams.ProductFilter.Subscription === null) {
        this.recurrenceOptions.productFilter = false;
        this.recurrenceOptions.subscriptionFilter = false;
      } else if (this.searchCatalogParams.ProductFilter.Subscription === false) {
        this.recurrenceOptions.productFilter = true;
        this.recurrenceOptions.subscriptionFilter = false;
      } else if (this.searchCatalogParams.ProductFilter.Subscription === true) {
        this.recurrenceOptions.productFilter = false;
        this.recurrenceOptions.subscriptionFilter = true;
      }
    }
  }, {
    key: "initStructureTypes",
    value: function initStructureTypes() {
      var _this3 = this;
      this.structureTypes.forEach(function (structureType) {
        structureType.selected = !!_this3.searchCatalogParams.ProductFilter.StructureTypes.find(function (id) {
          return id === structureType.id;
        });
        if (structureType.selected) {
          _this3.selectedStructureTypes.push(structureType.id);
        }
      });
    }
  }, {
    key: "setSubscriptionValue",
    value: function setSubscriptionValue() {
      if (this.hideRecurrence) {
        this.subscription = false;
      } else if (this.recurrenceOptions.productFilter && this.recurrenceOptions.subscriptionFilter || !this.recurrenceOptions.productFilter && !this.recurrenceOptions.subscriptionFilter) {
        this.subscription = null;
      } else {
        this.subscription = this.recurrenceOptions.subscriptionFilter ? this.recurrenceOptions.subscriptionFilter : !this.recurrenceOptions.productFilter;
      }
    }
  }, {
    key: "onRecurrenceChanged",
    value: function onRecurrenceChanged() {
      this.setSubscriptionValue();
      this._updateSearchCatalogParams();
    }
  }, {
    key: "onClearStructureType",
    value: function onClearStructureType() {
      this._clearStructureTypes();
      this._updateSearchCatalogParams();
    }
  }, {
    key: "onClearFacetsCategories",
    value: function onClearFacetsCategories() {
      if (this.selectedFacets) {
        this.clearFacets(this.facets);
      }
      if (this.selectedCategories) {
        this.clearCategories(this.categories);
      }
      this._updateSearchCatalogParams();
    }
  }, {
    key: "onClassChanged",
    value: function onClassChanged() {
      this._updateSearchCatalogParams();
    }
  }, {
    key: "onStructureTypeChanged",
    value: function onStructureTypeChanged(structureType) {
      this._setSelectedItems(this.selectedStructureTypes, structureType, STRUCTURE_TYPE_VALUE);
      this._updateSearchCatalogParams();
    }
  }, {
    key: "onFacetChanged",
    value: function onFacetChanged(facet) {
      this._updateFacet(facet);
      this._updateSearchCatalogParams();
    }
  }, {
    key: "onClearFacet",
    value: function onClearFacet(facet) {
      facet.selected = false;
      this._updateFacet(facet);
      this._updateSearchCatalogParams();
    }
  }, {
    key: "onSubFacetChanged",
    value: function onSubFacetChanged(facet, subFacet) {
      this._updateSubFacet(facet, subFacet);
      this._updateSearchCatalogParams();
    }
  }, {
    key: "onClearCategory",
    value: function onClearCategory(category) {
      category.selected = false;
      this._updateCategory(category);
      this._updateSearchCatalogParams();
    }
  }, {
    key: "onCategoryChanged",
    value: function onCategoryChanged(category) {
      this._updateCategory(category);
      this._updateSearchCatalogParams();
    }
  }, {
    key: "onSubCategoryChanged",
    value: function onSubCategoryChanged(category, subCategory) {
      this._updateSubCategory(category, subCategory);
      this._updateSearchCatalogParams();
    }
  }, {
    key: "_setShouldShowClearItem",
    value: function _setShouldShowClearItem(item, property) {
      var selectedItemCount = item[property].filter(function (subItem) {
        return subItem.selected;
      }).length;
      item.shouldShowClear = selectedItemCount > 1;
    }
  }, {
    key: "_setSelectedItems",
    value: function _setSelectedItems(list, item, property) {
      var foundIndex = list.indexOf(item[property]);
      if (foundIndex === -1 && item.selected) {
        list.push(item[property]);
      } else if (foundIndex > -1 && !item.selected) {
        list.splice(foundIndex, 1);
      }
    }
  }, {
    key: "_clearStructureTypes",
    value: function _clearStructureTypes() {
      var _this4 = this;
      this.structureTypes.forEach(function (structureType) {
        structureType.selected = false;
        _this4._setSelectedItems(_this4.selectedStructureTypes, structureType, STRUCTURE_TYPE_VALUE);
      });
    }
  }, {
    key: "_updateFacet",
    value: function _updateFacet(facet) {
      var _this5 = this;
      facet.subFacets.forEach(function (subFacet) {
        subFacet.selected = facet.selected;
        _this5._setSelectedItems(_this5.selectedFacets, subFacet, FACET_VALUE);
      });
      facet.indeterminate = false;
      this._setShouldShowClearItem(facet, FACET_LIST_PROPERTY);
    }
  }, {
    key: "_clearFacet",
    value: function _clearFacet(facet) {
      facet.selected = false;
      this._updateFacet(facet);
    }
  }, {
    key: "_updateSubFacet",
    value: function _updateSubFacet(facet, subFacet) {
      var selectedCount = facet[FACET_LIST_PROPERTY].filter(function (subItem) {
        return subItem.selected;
      }).length;
      facet.indeterminate = this._isIndeterminate(selectedCount, facet[FACET_LIST_PROPERTY].length);
      facet.selected = this._shouldParentBeSelected(selectedCount, facet[FACET_LIST_PROPERTY].length);
      this._setShouldShowClearItem(facet, FACET_LIST_PROPERTY);
      this._setSelectedItems(this.selectedFacets, subFacet, FACET_VALUE);
    }
  }, {
    key: "_clearCategory",
    value: function _clearCategory(category) {
      category.selected = false;
      this._updateCategory(category);
    }
  }, {
    key: "_updateCategory",
    value: function _updateCategory(category) {
      var _this6 = this;
      category.indeterminate = false;
      if (category.Children) {
        category.Children.forEach(function (subCategory) {
          subCategory.selected = category.selected;
          _this6._setSelectedItems(_this6.selectedCategories, subCategory, CATEGORY_VALUE);
        });
        this._setShouldShowClearItem(category, CATEGORY_LIST_PROPERTY);
      } else {
        this._setSelectedItems(this.selectedCategories, category, CATEGORY_VALUE);
      }
    }
  }, {
    key: "_updateSubCategory",
    value: function _updateSubCategory(category, subCategory) {
      var selectedCount = category[CATEGORY_LIST_PROPERTY].filter(function (subItem) {
        return subItem.selected;
      }).length;
      category.indeterminate = this._isIndeterminate(selectedCount, category[CATEGORY_LIST_PROPERTY].length);
      category.selected = this._shouldParentBeSelected(selectedCount, category[CATEGORY_LIST_PROPERTY].length);
      this._setShouldShowClearItem(category, CATEGORY_LIST_PROPERTY);
      this._setSelectedItems(this.selectedCategories, subCategory, CATEGORY_VALUE);
    }
  }, {
    key: "_updateSearchCatalogParams",
    value: function _updateSearchCatalogParams() {
      if (this.onSearchCatalogParamsUpdated) {
        this.searchCatalogParams.ProductFilter.ProductClassification = this.productClassification === PRODUCT_CLASSIFICATIONS.NONE ? null : this.productClassification;
        this.searchCatalogParams.ProductFilter.Subscription = this.subscription;
        this.searchCatalogParams.ProductFilter.Categories = this.selectedCategories;
        this.searchCatalogParams.ProductFilter.Facets = this.selectedFacets;
        this.searchCatalogParams.ProductFilter.StructureTypes = this.selectedStructureTypes;
        this.onSearchCatalogParamsUpdated()(this.searchCatalogParams);
      }
    }
  }, {
    key: "_shouldParentBeSelected",
    value: function _shouldParentBeSelected(selectedCount, totalChildrenCount) {
      return selectedCount > 0 && selectedCount === totalChildrenCount;
    }
  }, {
    key: "_isIndeterminate",
    value: function _isIndeterminate(selectedCount, totalChildrenCount) {
      return selectedCount > 0 && selectedCount !== totalChildrenCount;
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      // TODO: Customer Order: This component should be a true visual component. This logic should be handled by
      // the parent and passed in. This was done like this due to the component handling it's own view model internally
      if (changesObj.cartClassification && !changesObj.cartClassification.isFirstChange() && changesObj.cartClassification.currentValue !== changesObj.cartClassification.previousValue) {
        this.productClassification = !changesObj.cartClassification.currentValue ? PRODUCT_CLASSIFICATIONS.NONE : changesObj.cartClassification.currentValue;
        this.onClassChanged();
      }
    }
  }]);
}();
export default {
  bindings: {
    cartClassification: '<',
    categories: '<',
    disableClassifications: '<',
    facets: '<',
    hideRecurrence: '<',
    onSearchCatalogParamsUpdated: '&',
    productClass: '<',
    recurrenceOptions: '<',
    searchCatalogParams: '<',
    showClassificationFilter: '<',
    usePersistence: '<'
  },
  template: require('./advanced.search.filter.bar.html'),
  controller: CategoryFiltersController
};